const email = 'info@foxartbox.com'
const phone = '+359 (88) 27-444-30'

export {email, phone}